/*global Power2 */

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './Works.css';
import Smooth from '../../vendors/smooth';
import data from './projects.json';
import GlobalStore from '../../base/globalStore';
import { getPositionStart, getPositionEnd } from '../../helpers/offset.js';

import WorkItem from '../WorkItem/WorkItem';
// import { TimelineMax } from 'gsap';
import { TweenMax } from 'gsap';

//Redux
import { setProjectActive } from '../../actions';

class Works extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProjectHovered: false,
      active: false,
    };

    this.data = data;
    this.edge = 0;
    this.right = GlobalStore.config.isMobile ? 0 : 11;
  }

  componentWillMount() {
    // this.props.fetchWorksData(data);
  }

  componentDidMount() {
    this.bindEvents();
    setTimeout(() => {
      this.resize();
      this.smooth = new Smooth({ smoothContainer: false });
      // this.smoothElements = [];
      this.smooth.init();

      const sidebar = this.refs.sidebar.querySelector('.sidebar_wrapper');
      const padding = 80;
      let element = {
        el: sidebar,
        animations: [
          {
            transform: [
              {
                start: this.top,
                end: this.bottom,
                initialValue: 0,
                finalValue: GlobalStore.get('viewport').height - 72 - padding,
                transformType: 'translate3d',
                axis: 'y',
                ease: 0.05,
              },
            ],
          },
        ],
      };

      this.smooth.addElement(element);
      this.smooth.start();

      this.setupDom();
    }, 0);
  }

  bindEvents() {
    console.log('this.elVideo', this.elVideo);

    GlobalStore.on('change:viewport', () => this.resize());
    GlobalStore.on('change:scroll', () => this.scrollUpdate());

    // this.elVideo.addEventListener("progress", (e) => this.onProgress(e));
  }

  scrollUpdate() {
    const scrollY = GlobalStore.get('scroll').currentY;
    const before = scrollY < this.top;
    const after = scrollY > this.bottom;

    // If we are before/after the first/`last frame, set the styles according first/last value.
    // if(before || after) {

    if (before || after) {
      // we are at firt or last and allready setStyle to reach initial/final Value
      if ((before && this.edge === -1) || (after && this.edge === 1)) {
        // continue;
      } else {
        this.edge = before ? -1 : 1;
        this.setState({ active: false });
        this.refs.sidebar.style.position = 'absolute';
        this.refs.sidebar.style.top =
          this.edge === -1 ? '0px' : this.refs.el.offsetHeight - GlobalStore.get('viewport').height + 'px';
        this.refs.sidebar.style.right = this.right + 'px';
      }
    } else {
      if (!this.state.active) {
        this.edge = 0;
        this.setState({ active: true });
        this.refs.sidebar.style.position = 'fixed';
        this.refs.sidebar.style.top = '0px';

        let right = 0;
        if (GlobalStore.get('viewport').width >= 1366) {
          right = GlobalStore.get('viewport').width - this.refs.wrapper.getBoundingClientRect().right;
        } else {
          right = 0;
        }

        this.refs.sidebar.style.right = this.right + right + 'px';
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.current_active_project !== this.props.current_active_project) {
      let index = parseFloat(this.props.current_active_project) + 1;
      const sidebar_height = GlobalStore.config.isMobile ? 24 : 36;

      TweenMax.killTweensOf(this.refs.sidebar.querySelector('.digit'));
      TweenMax.killTweensOf(this.refs.sidebar.querySelector('.single'));

      TweenMax.to(this.refs.sidebar.querySelector('.digit'), 1, { y: -index * sidebar_height, ease: Power2.easeOut });
      TweenMax.to(this.refs.sidebar.querySelector('.single'), 1, {
        y: -index * sidebar_height,
        ease: Power2.easeOut,
        delay: 0.1,
      });
    }
  }

  onProjectHovered(projectId) {
    //this.refs.workFocus.style.top = window.pageYOffset + 'px';
    // this.showProjectFocus();
  }

  onProjectLeave() {
    // this.hideProjectFocus();
  }

  // ANIMATION AND DOM PARTS

  setupDom() {
    // TweenMax.set(this.elFocusTitle, {opacity: 0, y:50});
    // TweenMax.set(this.elFocusDesc, {opacity: 0, y:50});
    // TweenMax.set(this.elFocusRole, {opacity: 0,  y:50});
    // this.tlShowFocus = new TimelineMax({
    // 	paused: true
    // });
    // this.tlShowFocus
    // 	.to(this.elFocusTitle, .5, {opacity: 1, y:0}, 0)
    // 	.to(this.elFocusDesc, .5, {opacity: 1, y:0}, 0)
    // 	.to(this.elFocusRole, .5, {opacity: 1, y:0}, 0);
  }

  renderWorkItems() {
    let projects;
    const percentGrid = Math.round((100 / 12) * 100) / 100;

    if (this.data.projects) {
      projects = this.data.projects.map((work, index) => {
        /*return <WorkItem setProjectActive = { this.props.setProjectActive }
				ref = { 'work' + work.id }
				key = { work.id }
				actions = { this.props.actions }
				data = { work }
				/>*/

        if (work.container === true) {
          let children = [];

          for (let indexLoop = 0; indexLoop < work.children.length; indexLoop++) {
            let element = work.children[indexLoop];

            // Mobile ; we render only video item!
            if (GlobalStore.config.isMobile) {
              if (!element.quote && !element.image) {
                children.push(
                  <WorkItem
                    ref={'work' + element.id}
                    key={element.id}
                    actions={this.props.actions}
                    setProjectActive={this.props.setProjectActive}
                    data={element}
                    index={index}
                  />
                );
              }
            } else {
              if (element.quote) {
                children.push(
                  <div key={element.id} className="quote">
                    <h3>{element.quoteContent}</h3>
                  </div>
                );
              } else if (element.image) {
                const style = {
                  marginRight: element.offsetRight * percentGrid + '%',
                  marginLeft: element.offsetLeft * percentGrid + '%',
                };
                const className = 'image grid__col-' + element.col;

                children.push(
                  <div style={style} key={element.id} className={className}>
                    <img src={element.imageSource} role="presentation" />
                  </div>
                );
              } else {
                children.push(
                  <WorkItem
                    ref={'work' + element.id}
                    key={element.id}
                    actions={this.props.actions}
                    setProjectActive={this.props.setProjectActive}
                    data={element}
                    index={index}
                  />
                );
              }
            }
          }

          return (
            <div key={work.id} className="project-container grid__col-12">
              {children}
            </div>
          );
        } else {
          return (
            <WorkItem
              setProjectActive={this.props.setProjectActive}
              ref={'work' + work.id}
              key={work.id}
              actions={this.props.actions}
              data={work}
              index={index}
            />
          );
        }
      });
    }

    return projects;
  }

  resize() {
    console.log('resize Video');
    this.top = getPositionStart(this.refs.el, GlobalStore.get('viewport').height) + GlobalStore.get('viewport').height;
    this.bottom = getPositionEnd(this.refs.el, GlobalStore.get('viewport').height) - GlobalStore.get('viewport').height;
  }

  render() {
    console.log('render');
    const WorkItems = this.renderWorkItems();
    // const classNameSectionBackground = "section-background" + (this.state.isProjectHovered ? ' isProjectHovered' : '');
    // const classNameBackground = "background" + (this.state.isProjectHovered ? ' isProjectHovered' : '');

    return (
      <section ref="el" className="works-section">
        <div className="works-wrapper" ref="wrapper">
          <div className="grid">{WorkItems}</div>
        </div>
        <sidebar ref="sidebar">
          <div className="sidebar_wrapper">
            <div className="sidebar_mask">
              <div className="digit decimal">
                {Array.from({ length: this.data.projects.length + 1 }, (_, i) => (
                  <span key={i}> {Math.floor(i / 10)} </span>
                ))}
              </div>
              <div className="digit single">
                {Array.from({ length: this.data.projects.length + 1 }, (_, i) => (
                  <span key={i}> {i % 10} </span>
                ))}
              </div>
            </div>
            <span className="divider"> /{this.data.projects.length}</span>
          </div>
        </sidebar>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  current_active_project: state.work.current_active_project,
});

const mapDispatchToProps = (dispatch) => ({
  setProjectActive: bindActionCreators(setProjectActive, dispatch),
});

// export default Works;
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Works);



/** WEBPACK FOOTER **
 ** ./src/components/Works/Works.js
 **/